import { z } from 'zod';
/*
 * Вход по QR-коду.
 *
 * В коде лежит не ссылка, а помеченный секрет. Ссылка в QR — готовая почва
 * для подделки: человек привыкает открывать то, что пришло с чужого экрана.
 * Метка нужна, чтобы сканер сразу отличал наш код от посторонних и говорил
 * об этом понятно, а не пытался войти по случайной надписи.
 */
export const QR_LOGIN_PREFIX = 'andresot:login:';
/** Секрет — 32 случайных байта в base64url. */
export const qrTokenSchema = z.string().regex(/^[A-Za-z0-9_-]{43}$/);
export const qrIdParamsSchema = z.object({ id: z.string().cuid() }).strict();
export const qrTokenParamsSchema = z.object({ token: qrTokenSchema }).strict();
export const qrPollQuerySchema = z.object({ poll: qrTokenSchema });
/** Собрать содержимое кода. */
export function qrLoginPayload(approveToken) {
    return `${QR_LOGIN_PREFIX}${approveToken}`;
}
/** Разобрать распознанное камерой. Чужой код даёт null, а не попытку входа. */
export function parseQrLoginPayload(text) {
    if (!text.startsWith(QR_LOGIN_PREFIX))
        return null;
    const token = text.slice(QR_LOGIN_PREFIX.length);
    return qrTokenSchema.safeParse(token).success ? token : null;
}
//# sourceMappingURL=qr.js.map